/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const GipAodRuleEvidenceExportOptionsDtoMediaTypeEnum = {
    AUDIO: "AUDIO",
    VIDEO: "VIDEO"
} as const;

export type GipAodRuleEvidenceExportOptionsDtoMediaTypeEnumKey = (typeof GipAodRuleEvidenceExportOptionsDtoMediaTypeEnum)[keyof typeof GipAodRuleEvidenceExportOptionsDtoMediaTypeEnum];

export const GipAodRuleEvidenceExportOptionsDtoPackageStorageStrategyEnum = {
    PER_RUN: "PER_RUN",
    PER_RULE: "PER_RULE"
} as const;

export type GipAodRuleEvidenceExportOptionsDtoPackageStorageStrategyEnumKey = (typeof GipAodRuleEvidenceExportOptionsDtoPackageStorageStrategyEnum)[keyof typeof GipAodRuleEvidenceExportOptionsDtoPackageStorageStrategyEnum];

/**
 * GipAodRuleEvidenceExportOptions
 * @description Export options for GIP AOD rules (evidence package options + AOD-specific settings).
*/
export type GipAodRuleEvidenceExportOptionsDto = {
    /**
     * @description Exclude version in filenames and CSV/XLS files
     * @deprecated
     * @default false
     * @type boolean | undefined
    */
    excludeVersion?: boolean;
    /**
     * @description Include public link in filenames and CSV/XLS files
     * @deprecated
     * @default false
     * @type boolean | undefined
    */
    publicLink?: boolean;
    /**
     * @description Selected report definition id to use for the report export to XLS
     * @type string | undefined
    */
    definitionId?: string;
    /**
     * @description The type of media to package
     * @default "AUDIO"
     * @type string | undefined
    */
    mediaType?: GipAodRuleEvidenceExportOptionsDtoMediaTypeEnumKey;
    /**
     * @description Seconds to include before the match start
     * @minLength 0
     * @default 0
     * @type number | undefined
    */
    audioMatchIncludeBefore?: number;
    /**
     * @description Seconds to include after the match end
     * @minLength 0
     * @default 0
     * @type number | undefined
    */
    audioMatchIncludeAfter?: number;
    /**
     * @description Path formatting options
     * @type object | undefined
    */
    pathFormat?: {
        /**
         * @description Selected EvidencePackagePathFormat (stored in client config) id
         * @type string | undefined
        */
        formatId?: string;
        /**
         * @description If the selected EvidencePackagePathFormat (stored in client config) includes the CUSTOM_TEXT token, use this value to replace it
         * @type string | undefined
        */
        formatCustomText?: string;
    };
    /**
     * @description Whether to store a new evidence export file per run (PER_RUN) or reuse the same file for all runs in the rule (PER_RULE). Only applicable when used as AOD rule export options.
     * @default "PER_RUN"
     * @type string | undefined
    */
    packageStorageStrategy?: GipAodRuleEvidenceExportOptionsDtoPackageStorageStrategyEnumKey;
};